import React, { useState, useEffect } from "react";
import { Card, Button, ProgressBar } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import FileUploadStatus from "./FileUploadStatus";
import { YESNO } from "../../Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { getAll } from "../../store/LibrarySlice";
import { useDispatch } from "react-redux";

const CHUCK_SIZE = 1024 * 1024 * 1;
const LibraryUploadSection = (props) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const { onClose } = props;

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'video/mp4': ['.mp4']
    },
    onDrop: (acceptedFiles) => {
      setFiles([...acceptedFiles]);
      
      // Process each file
      acceptedFiles.forEach(file => {
        const fileChunks = [];
        let index = 0;

        // Create chunks
        for (let cur = 0; cur < file.size; cur += CHUCK_SIZE) {
          fileChunks.push({
            filename: file.name,
            hash: index++,
            chunk: file.slice(cur, cur + CHUCK_SIZE),
          });
        }

        // Upload chunks
        const uploadPromises = fileChunks.map(chunk => {
          const formData = new FormData();
          formData.append("filename", chunk.filename);
          formData.append("hash", chunk.hash);
          formData.append("chunk", chunk.chunk);
          return axios.post("/api/media/upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        });

        Promise.all(uploadPromises)
          .then(async () => {
            // Merge chunks
            const r1 = await axios.get("/api/media/upload/merge", {
              params: { filename: file.name }
            });

            // Register media
            const body = {
              ...r1.data,
              path: file.path || file.name,
              size: file.size,
              type: file.type,
            };

            // await axios.post("/api/media/upload/register", body);
            
            // Generate thumbnail (works for both images and videos)
            await axios.post("/api/media/upload/generateThumb", body);
          })
          .then(() => {
            setTimeout(() => dispatch(getAll()), 2000);
          })
          .catch(error => {
            console.error("Upload failed:", error);
          });
      });
    }
  });

  const handleClose = () => {
    onClose && onClose();
  };
  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between">
          <div />
          <div style={{ cursor: "pointer" }} onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <section className="container">
          <div {...getRootProps({ className: "dropzone " })}>
            <input {...getInputProps()} />

            <div className="h3">
              Drop files here or click <Button>Select Files</Button> to upload.
            </div>
          </div>
        </section>
      </Card.Body>

      <Card.Footer>
        {files.map((file, i) => {
          return <FileUploadStatus key={i} file={file} />;
        })}
      </Card.Footer>
    </Card>
  );
};
export default LibraryUploadSection;
